module.exports = __webpack_public_path__ + "static/media/29COICT9.60e3849a.jpg";